/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The InlineResponse2004 model module.
 * @module model/InlineResponse2004
 * @version v0.3
 */
export default class InlineResponse2004 {
  /**
   * Constructs a new <code>InlineResponse2004</code>.
   * @alias module:model/InlineResponse2004
   * @class
   * @param termsAcceptedAt {Date} Time when terms acceptance was recorded. Null means no acceptance record.
   * @param activationStatus {module:model/InlineResponse2004.ActivationStatusEnum}
   */
  constructor(termsAcceptedAt, activationStatus) {
    this.termsAcceptedAt = termsAcceptedAt;
    this.activationStatus = activationStatus;
  }

  /**
   * Constructs a <code>InlineResponse2004</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/InlineResponse2004} obj Optional instance to populate.
   * @return {module:model/InlineResponse2004} The populated <code>InlineResponse2004</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new InlineResponse2004();
      if (data.hasOwnProperty('terms_accepted_at'))
        obj.termsAcceptedAt = ApiClient.convertToType(data['terms_accepted_at'], 'Date');
      if (data.hasOwnProperty('activation_status'))
        obj.activationStatus = ApiClient.convertToType(data['activation_status'], 'String');
    }
    return obj;
  }
}

/**
 * Time when terms acceptance was recorded. Null means no acceptance record.
 * @member {Date} termsAcceptedAt
 */
InlineResponse2004.prototype.termsAcceptedAt = undefined;

/**
 * Allowed values for the <code>activationStatus</code> property.
 * @enum {String}
 * @readonly
 */
InlineResponse2004.ActivationStatusEnum = {
  /**
   * value: "activated"
   * @const
   */
  activated: "activated",

  /**
   * value: "pending"
   * @const
   */
  pending: "pending",

  /**
   * value: "overdue"
   * @const
   */
  overdue: "overdue",

  /**
   * value: "null"
   * @const
   */
  _null: "null"
};
/**
 * @member {module:model/InlineResponse2004.ActivationStatusEnum} activationStatus
 */
InlineResponse2004.prototype.activationStatus = undefined;
